import { defineMessage } from 'services/localization';

export const messages = {
    active: defineMessage('active_2'),
    reviewed: defineMessage('reviewed'),
    forceReviewedBy: defineMessage('force_reviewed_by_name'),
    activeStep: defineMessage('active_step_1'),
    reviewStep: defineMessage('review_step_2'),
    skipped: defineMessage('skipped'),
};
